import React, { useState, useEffect } from 'react'
import SubHeader from '../general/SubHeader';

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [fullScreen, setFullScreen] = useState(false);
    const [fullScreenImageUrl, setFullScreenImageUrl] = useState('');


    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await fetch('https://apis.anvifoundation.com/anvi/get-images');
                if (response.ok) {
                    const data = await response.json();
                    setImages(data.images);  // Set images array to state
                } else {
                    alert('Failed to fetch images.');
                }
            } catch (error) {
                console.error('Error fetching images:', error);
                alert('Error fetching images.');
            }
        };

        fetchImages();
    }, []);  // Empty dependency array means this runs only once when the component mounts


    const handleOpenFullScreen = (imageUrl) => {
        setFullScreenImageUrl(imageUrl); // Set the image URL for full-screen view
        setFullScreen(true); // Open full-screen view
    };

    // Handle closing full screen view
    const handleCloseFullScreen = () => {
        setFullScreen(false); // Close full-screen view
        setFullScreenImageUrl(''); // Clear the image URL
    };

    return (
        <>
            <SubHeader message="Gallery" />

            {/* Gallery Section */}
            <section className='my-5'>
                <div className='container'>

                    <div className='row mt-4'>
                        {images.length > 0 ? (
                            images.map((imageUrl, index) => (
                                <div key={index} className="col-lg-3 col-6 my-2">
                                    <div className='image-area'>
                                        <img
                                            src={imageUrl}
                                            alt={`uploaded-image-${index}`}
                                            className="img-fluid"
                                        />

                                        <div className='image-area-inner' onClick={() => handleOpenFullScreen(imageUrl)}>
                                            <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
                                        </div>

                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No images available.</p>
                        )}
                    </div>

                </div>
            </section>
            {/* Gallery Section ends */}

            {fullScreen && (
                <section className='fullscreen-area'>
                    <div className="container">
                        <button className="imgClose-btn float-end" onClick={handleCloseFullScreen}><i className="fa-solid fa-xmark"></i></button>
                        <img src={fullScreenImageUrl} alt="Full Screen" className="img-fluid" />
                    </div>
                </section>
            )}

        </>
    )
}

export default Gallery
